import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BankOperationDetail } from '../../model/bank-operation.js';
import { bankTransactionQueries } from './bank-transaction-queries.js';

export const useBankOperationQuery = (id: string): UseQueryResult<BankOperationDetail> =>
  useQuery(bankTransactionQueries.detail(id));
